import { render, staticRenderFns } from "./event-activity.vue?vue&type=template&id=1c1a9052&lang=pug&"
import script from "./event-activity.vue?vue&type=script&lang=js&"
export * from "./event-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports